import { render, staticRenderFns } from "./ModalAlterarPrestador.vue?vue&type=template&id=343541b2&scoped=true"
import script from "./ModalAlterarPrestador.vue?vue&type=script&lang=ts"
export * from "./ModalAlterarPrestador.vue?vue&type=script&lang=ts"
import style0 from "./ModalAlterarPrestador.vue?vue&type=style&index=0&id=343541b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343541b2",
  null
  
)

export default component.exports